import { styled } from '@mui/material';

export const StyledDocumentsListContainer = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(4)
}));

export const StyledDocumentsListContent = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2)
}));
